export enum COUNTRIES {
  CN = 'CN',
  US = 'US',
  CA = 'CA',
  IN = 'IN',
  CL = 'CL',
  AR = 'AR',
  MT = 'MT',
  MX = 'MX',
  NZ = 'NZ',
}

export const COUNTRY_PLACEHOLDER_PHONE = {
  [COUNTRIES.CN]: '+86 131 2345 6789',
  [COUNTRIES.US]: '+1 234 234 2342',
  [COUNTRIES.CA]: '+1 204 234 2342',
  [COUNTRIES.IN]: '+91 099876 54321',
  [COUNTRIES.CL]: '+56 9 6123 4567',
  [COUNTRIES.AR]: '+54 11 2345 6789',
  [COUNTRIES.MT]: '+356 7912 3456',
  [COUNTRIES.MX]: '+52 1 234 234 2342',
  [COUNTRIES.NZ]: '+64 234 234 2342',
}

// Extend this const to support new currencies
export const CurrencyCodeByCountry =  {
  us: {
    code: 'us',
    currencyCode: 'USD',
    name: 'United States'
  },
  ca: {
    code: 'ca',
    currencyCode: 'CAD',
    name: 'Canada'
  },
}